<div echarts [options]="adaptedOptions()" [initOpts]="initOpts" class="ogive-chart"></div>
